module.exports = __webpack_public_path__ + "static/media/csv.9a81bc31.svg";